import { fetchPublicWabunkaApi } from '@/wabunka-src/common/composables/query/fetchPublicWabunkaApi';
import { buildWaitlistRegistrationRequest, type WaitlistRegistrationForm } from '@/wabunka-src/features/Experience/models/waitlistRegistration';

/**
 * ウェイトリスト登録を送信する Mutation Composable。
 *
 * backend: POST `/public/v1/consumer/waitlists`（認証不要・google.protobuf.Empty）。
 * 入力形式エラー・サーバエラーは `$fetch` のエラーとして throw されるため、呼び出し元（form）でハンドリングする。
 *
 * useFetch 系のラッパーは使わない。dedupe key が同一だと 2 回目以降の送信がキャッシュ済みの成功を
 * 返してリクエストごと飛ばないため、登録できていないのに完了表示になる（ADR-094）。
 */
export const useRegisterWaitlistMutation = () => {
  const registerMutate = async (form: WaitlistRegistrationForm, experienceId: string): Promise<void> => {
    await fetchPublicWabunkaApi({
      path: '/waitlists',
      method: 'POST',
      body: buildWaitlistRegistrationRequest(form, experienceId),
      converter: () => undefined,
    });
  };

  return { registerMutate };
};
